import * as superadminApi from '../../api/superadmin';
import { tenants, smtpConfig, success, error } from '../state';
import { askConfirm } from '../confirm';

export async function loadTenants() {
  try {
    tenants.value = await superadminApi.fetchTenants();
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function activarTenant(id: string, nombre: string) {
  const ok = await askConfirm('Activar empresa', `${nombre} va a poder iniciar sesión y usar el sistema.`, false);
  if (!ok) return;
  try {
    await superadminApi.setTenantActivo(id, true);
    await loadTenants();
    success.value = 'Empresa activada.';
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function desactivarTenant(id: string, nombre: string) {
  const ok = await askConfirm('Desactivar empresa', `${nombre} va a perder acceso al sistema hasta que la reactives.`, true);
  if (!ok) return;
  try {
    await superadminApi.setTenantActivo(id, false);
    await loadTenants();
    success.value = 'Empresa desactivada.';
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function loadSmtpConfig() {
  try {
    smtpConfig.value = await superadminApi.fetchSmtpConfig();
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function guardarSmtpConfig(data: Record<string, unknown>) {
  try {
    await superadminApi.saveSmtpConfig(data);
    await loadSmtpConfig();
    success.value = 'Configuración SMTP guardada.';
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function enviarSmtpPrueba(to: string) {
  try {
    await superadminApi.testSmtp(to);
    success.value = `Email de prueba enviado a ${to}.`;
  } catch (err) {
    error.value = (err as Error).message;
  }
}
